import React from "react";
import SectionHeader from "../common/SectionHeader";
import AdReccoView from "../AdRateCard/AdReccoView";

const AdReccoSection = () => {
  return (
    <section className="p-4 md:p-6">
      <SectionHeader title="View Recco" className="mb-4" />
      <AdReccoView />
    </section>
  );
};

export default AdReccoSection;
